const Notfoundpage = () => {
  return <h1>Page Not Found! Sorry!</h1>;
};

export default Notfoundpage;
